const convertToOrdinal = n => {
    if (n === 0) return n;

    return n + '.';
};

exports.convertToOrdinal = convertToOrdinal;
